import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ROLES } from '@constants/roles';
import {
    NotFound, LoginPage, SamplePage, Main,
    UtilsPage, AnimationPage, BoardPage, BoardList, Grid,
    ProcEqpt, Acc, Emp, Supv, Accident, Account, Code,
    CorpList, SiteList, Corpreg, Depart, Employee, Position,
    Current, Official, Organ, Prevent,
    ExcelUpload, DepartmentExcelUpload, PositionExcelUpload, HomePage, GuidePage,
    InquiryStatusPage, RolePermission, MenuManagement,
    ForgotIdPage, ForgotPasswordPage, ChangePasswordPage,
    BizCardList, BizCardUpload, BizCardReview, BizDashboard, BizCardSharePage,
} from '@pages';
import { AuthContext } from '@context';
import { DashCompanyList } from '@pages/dash/DashCompanyList';
import { DashSiteList } from '@pages/dash/DashSiteList';

import {ProtectedRoute, Layout} from '@components';
import {EmployeeExcelUpload} from "@pages/sample/EmployeeExcelUpload";
import AIAdminLayout from '@pages/ai/admin/AIAdminLayout';
import AIAdminDashboardPage  from '@pages/ai/admin/AIAdminDashboardPage';
import AIAdminInquiriesPage from '@pages/ai/admin/AIAdminInquiriesPage';
import ConsolePage from '@pages/ai/admin/ConsolePage';

// /dash 진입 시 권한별 분기 리다이렉트
function DashIndexRedirect() {
    const { auth } = useContext(AuthContext);
    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';
    return <Navigate to={isAdminOrR1 ? '/dash/company' : '/dash/site'} replace />;
}

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Navigate to="/" replace />} />


            {/* 아이디/비밀번호 찾기 - 인증 없이 접근 가능 */}
            <Route path="/forgot-id" element={<ForgotIdPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />

            {/* 명함 공유 링크 - 로그인 없이 접근 가능 */}
            <Route path="/share/:token" element={<BizCardSharePage />} />

            {/* 비밀번호 강제 변경 - 임시 비밀번호 로그인 후 접근 */}
            <Route path="/change-password" element={
                <ProtectedRoute roles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.COMP_ADMIN, ROLES.USER]}>
                    <ChangePasswordPage />
                </ProtectedRoute>
            } />


            <Route path="/guide/:type" element={<GuidePage />} />

            <Route path="/board" element={<Layout><BoardPage /></Layout>} />
            <Route path="/boardList" element={<Layout><BoardList /></Layout>} />
            <Route path="/grid" element={<Layout><Grid /></Layout>} />

            <Route path="/utils" element={<Layout><UtilsPage /></Layout>} />
            <Route path="/animation" element={<Layout><AnimationPage /></Layout>} />
            <Route path="/sample" element={<Layout><SamplePage /></Layout>} />

            <Route path="/main" element={
                <ProtectedRoute>
                    <Layout><Main /></Layout>
                </ProtectedRoute>
            } />

            {/* 대시보드 진입 - 권한별 분기 */}
            <Route path="/dash" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/current">
                    <DashIndexRedirect />
                </ProtectedRoute>
            } />

            {/* 대시보드 - 회사 선택 (R0/R1 전용) */}
            <Route path="/dash/company" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/current">
                    <Layout><DashCompanyList /></Layout>
                </ProtectedRoute>
            } />

            {/* 대시보드 - 사업장 선택 */}
            <Route path="/dash/site" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/current">
                    <Layout><DashSiteList /></Layout>
                </ProtectedRoute>
            } />



            <Route path="/comp/corpreg" element={
                <ProtectedRoute requiredPermission="COMPANY_READ" menuPath="/comp/corpreg">
                    <Layout><Corpreg /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comp/SiteList" element={
                <ProtectedRoute requiredPermission="SITE_READ" menuPath="/comp/SiteList">
                    <Layout><SiteList /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comp/depart" element={
                <ProtectedRoute requiredPermission="DEPT_READ" menuPath="/comp/depart">
                    <Layout><Depart /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comp/position" element={
                <ProtectedRoute requiredPermission="POS_READ" menuPath="/comp/position">
                    <Layout><Position /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comp/employee" element={
                <ProtectedRoute requiredPermission="EMPLOYEE_READ" menuPath="/comp/employee">
                    <Layout><Employee /></Layout>
                </ProtectedRoute>
            } />


            <Route path="/acci/ProcEqpt" element={
                <ProtectedRoute requiredPermission="ACCIDENT_READ" menuPath="/acci/ProcEqpt">
                    <Layout><ProcEqpt /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/acci/acc" element={
                <ProtectedRoute requiredPermission="ACCIDENT_READ" menuPath="/acci/acc">
                    <Layout><Acc /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/acci/emp" element={
                <ProtectedRoute requiredPermission="ACCIDENT_READ" menuPath="/acci/emp">
                    <Layout><Emp /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/acci/supv" element={
                <ProtectedRoute requiredPermission="ACCIDENT_READ" menuPath="/acci/supv">
                    <Layout><Supv /></Layout>
                </ProtectedRoute>
            } />


            <Route path="/dash/current" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/current">
                    <Layout><Current /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/dash/official" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/official">
                    <Layout><Official /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/dash/organ" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/organ">
                    <Layout><Organ /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/dash/prevent" element={
                <ProtectedRoute requiredPermission="DASHBOARD_READ" menuPath="/dash/prevent">
                    <Layout><Prevent /></Layout>
                </ProtectedRoute>
            } />


            <Route path="/comm/code" element={
                <ProtectedRoute requiredPermission="CODE_READ" menuPath="/comm/code">
                    <Layout><Code /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comm/account" element={
                <ProtectedRoute requiredPermission="USER_READ" menuPath="/comm/account">
                    <Layout><Account /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comm/accident" element={
                <ProtectedRoute requiredPermission="ACCIDENT_READ" menuPath="/comm/accident">
                    <Layout><Accident /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comm/role" element={
                <ProtectedRoute requiredPermission="ROLE_READ" menuPath="/comm/role">
                    <Layout><RolePermission /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comm/menu" element={
                <ProtectedRoute requiredPermission="MENU_READ" menuPath="/comm/menu">
                    <Layout><MenuManagement /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/comp/corpList" element={
                <ProtectedRoute requiredPermission="COMPANY_READ" menuPath="/comp/corpList">
                    <Layout><CorpList /></Layout>
                </ProtectedRoute>
            } />

            {/* 시스템 관리 - 엑셀 업로드 */}
            <Route path="/systemExcelUpload" element={
                <ProtectedRoute requiredPermission="SITE_WRITE" menuPath="/systemExcelUpload">
                    <Layout><ExcelUpload /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/departExcelUpload" element={
                <ProtectedRoute requiredPermission="DEPT_WRITE" menuPath="/departExcelUpload">
                    <Layout><DepartmentExcelUpload /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/positionExcelUpload" element={
                <ProtectedRoute requiredPermission="POS_WRITE" menuPath="/positionExcelUpload">
                    <Layout><PositionExcelUpload /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/employeeExcelUpload" element={
                <ProtectedRoute requiredPermission="EMPLOYEE_WRITE" menuPath="/employeeExcelUpload">
                    <Layout><EmployeeExcelUpload /></Layout>
                </ProtectedRoute>
            } />


            <Route path="/ai" element={
                <ProtectedRoute requiredPermission="AI_READ" menuPath="/ai">
                    <Layout noFooter><InquiryStatusPage /></Layout>
                </ProtectedRoute>
            } />


            <Route path="/ai/admin" element={
                <ProtectedRoute requiredPermission="AI_ADMIN" menuPath="/ai/admin">
                    <Layout><AIAdminLayout><AIAdminDashboardPage /></AIAdminLayout></Layout>
                </ProtectedRoute>
            } />

            <Route path="/ai/admin/inquiries" element={
                <ProtectedRoute requiredPermission="AI_ADMIN" menuPath="/ai/admin">
                    <Layout><AIAdminLayout><AIAdminInquiriesPage /></AIAdminLayout></Layout>
                </ProtectedRoute>
            } />

            <Route path="/ai/admin/console/*" element={
                <ProtectedRoute requiredPermission="AI_ADMIN" menuPath="/ai/admin">
                    <Layout><AIAdminLayout><ConsolePage /></AIAdminLayout></Layout>
                </ProtectedRoute>
            } />


            {/* 명함 관리 */}
            <Route path="/biz/dashboard" element={
                <ProtectedRoute requiredPermission="CARD_READ" menuPath="/biz/dashboard">
                    <Layout><BizDashboard /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/biz/card-list" element={
                <ProtectedRoute requiredPermission="CARD_READ" menuPath="/biz/card-list">
                    <Layout><BizCardList /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/biz/card-upload" element={
                <ProtectedRoute requiredPermission="CARD_WRITE" menuPath="/biz/card-upload">
                    <Layout><BizCardUpload /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/biz/card-review/:cardId" element={
                <ProtectedRoute requiredPermission="CARD_WRITE" menuPath="/biz/card-upload">
                    <Layout><BizCardReview /></Layout>
                </ProtectedRoute>
            } />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default AppRoutes;